<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <div class="selectBox">
      <div class="px-4">
        <v-row no-gutters v-for="(item, index) in confirmation.items" v-bind:key="index">
          <v-col cols="auto">
            <v-checkbox
                v-model="item.default"
                class="mt-0 confirmation-checkbox"
                :color="bot_setting.main_color"
                @change="enableSubmitButton"
              >
            </v-checkbox>
          </v-col>
          <v-col class="mt-1">
              <span style="white-space: pre-wrap;" v-html="item.value"></span>
          </v-col>
        </v-row>
        <div class="my-2 red--text darken-1 confirmation-message" v-if="confirmationValid == false">{{confirmation.error_message}}</div>
      </div>
      <div class="mb-5 px-5" v-if="isFinalQuestion()">
        <div><span style="font-size:small; font-weight:bold">弁護士法人ネクサス法律事務所は個人情報の保護に取り組んでおります。</span></div>
        <div><span style="font-size:small">ご入力いただいた個人情報は、<a href="../privacy.html" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に基づいて適切に取り扱います。内容をご確認いただき、同意の上で下記ボタンを押してください。</span></div>
      </div>
      <div class="itemlist">
        <div class="selectItem" v-for="(item, index) in selection_options" v-bind:key="index"><label><button :disabled="btnDisabled" @click="submit(index)">{{item.title}}</button></label></div>
      </div>   
    </div>
  </div>
</template>

<script>
export default {

  name: "SingleSelectionInput",

  props: ['placeholder', 'error_message', 'bot_setting', 'is_required', 'selection_options', 'confirmation', 'label_name'],

  created(){
    //console.log(this.selection_options)
  },

  data: () =>({
    confirmationValid: true,
    btnDisabled: false
  }),


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(data){
      if (this.validateConfirmation() == true) {
        this.btnDisabled = true
        var emitValue = {user_chat_message: this.selection_options[data].title, user_chat_value:this.selection_options[data].value}
        this.$emit('single_selection_input_submitted', emitValue)
      }else{
        this.btnDisabled = false
      }
    },
    validateConfirmation(){
      this.confirmationValid = true
      for(var i=0; i < this.confirmation.items.length; i++){
        if (this.confirmation.items[i].default == false){
          this.confirmationValid = false
        }
      }
      if (this.confirmationValid == true) {
        return true
      }
      return false
    },
    enableSubmitButton(){
      this.btnDisabled = false
    },
    isFinalQuestion(){
      if (this.label_name.indexOf('final') === 0){
        return true
      }else{
        return false
      }
    }
  }
}
</script>